import * as React from "react";
const SvgFiRrTruckFront = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-truck-front_svg__a)">
      <path
        fill="#062147"
        d="M24 5c0-2.757-2.243-5-5-5H5C2.243 0 0 2.243 0 5v10c0 .978.36 1.919 1 2.645V18a4 4 0 0 0 2 3.463V22a2 2 0 1 0 4 0h10a2 2 0 1 0 4 0v-.537A4 4 0 0 0 23 18v-.355c.64-.726 1-1.667 1-2.645zM3.723 14l1.993-3.488A3 3 0 0 1 8.32 9h7.357c1.073 0 2.071.579 2.604 1.512L20.274 14zM5 2h14c1.654 0 3 1.346 3 3v7.985l-1.98-3.466a5.01 5.01 0 0 0-4.341-2.52H8.322a5.01 5.01 0 0 0-4.341 2.52l-1.98 3.466V5c0-1.654 1.345-3 2.999-3m16 16c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-1.406q0-.298.036-.594H5v1a1 1 0 1 0 2 0v-1h10v1a1 1 0 1 0 2 0v-1h1.964q.036.295.036.594z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-truck-front_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTruckFront;
